module.exports = __webpack_public_path__ + "static/media/brachypodium_distachyon.flower_parts.1de18558.svg";